import { FC } from 'react';

export type CloseIconProps = { variant?: 'default' | 'white' };
export const Close: FC<CloseIconProps> = ({ variant = 'default' }) => {
  const color = variant === 'white' ? '#ffffff' : '#707475';
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="close"
    >
      <path d="M1 21L21 1" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M21 21L1 1" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
